<template>
  <div class="list row">
    <h2>Države</h2>
    <div class="actions d-flex flex-row-reverse">
      <button
        type="button"
        class="btn btn-primary bi bi-arrow-clockwise"
        @click="refreshData"
      />
      <button
        type="button"
        class="btn btn-success bi bi-plus"
        @click="addData"
      />
    </div>
    <data-table
      url="countries"
      :columns="columns"
      :headings="headers"
      :actions="actions"
      ref="datatable"
      @yes="deleteData"
      name="countries"
    >
    </data-table>
  </div>
</template>

<script>
import CountriesDataService from "../../services/countries.service";
import DataTable from "../widgets/DataTable.vue";
import CountriesForm from "./CountriesForm.vue";

export default {
  name: "countries",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: ["code", "name", "code_alpha", "code_num", "edit"],
      headers: {
        code: "Oznaka",
        usd: "Naziv",
        aud: "Šifra (alfa)",
        sek: "Šifra (numerička)",
        edit: "",
      },
      actions: {
        edit: { commp: CountriesForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
        // print: null,
      },
      currentTutorial: null,
      currentIndex: -1,
      title: "",
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: CountriesForm,
        params: {
          data: {},
          title: "Dodaj novu državu",
        },
      });
    },
    deleteData(id) {
      CountriesDataService.delete(id)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message,
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
  },
};
</script>

<style scoped>
/* .list {
  text-align: left;
  
  margin: auto;
} */
:root > td:nth-of-type(1) {
  text-align: center;
}
</style>
